// Mirrors Automy.Core.Enums.DocumentManager.DocumentSource (C# member names
// are used in OData filters — keep keys in sync with the backend enum).
export default Object.freeze({
  ProcessInstanceFormFieldAttachment: 1,
  ProcessInstanceGeneratedDocument: 2,
  ProcessInstanceVariableAttachment: 3,
  ProcessInstanceCommentAttachment: 4,
  EntityAttachment: 5,
  ProcessInstanceApiCallAttachment: 6,
  ListExportGeneratedFile: 7,
  DynamicEntityExportGeneratedFile: 8,
  DynamicEntityImportGeneratedErrorFile: 9,
  ProcessInstanceOpenAICallAttachment: 10,
  ProcessInstanceAutomyAIAttachment: 11,
  ProcessInstanceRunCodeAttachment: 12,
  ChatThreadAttachment: 13,
  ConfigurationEntityExportGeneratedFile: 14,
  ConfigurationEntityImportGeneratedErrorFile: 15,
  ManualUpload: 17,
  DocumentManagerBulkExportGeneratedFile: 18,
});
